import { useNavigate } from "react-router-dom";
import searchIcon from "../../assets/images/search_rgb_red.svg";
import checkboxIcon from "../../assets/images/check_box_rgb_red.svg";
import {
  Button,
  Col,
  Container,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import "../../assets/styles/addresses.scss";

const DataImportButtons = ({ onSearch, onAccept, onReject, selectedIds = [], isSuperUser = false }) => {
  const navigate = useNavigate();

  const renderAcceptTooltip = (props) => (
    <Tooltip id="accept-tooltip" {...props}>
      Akceptuj zaznaczone ({selectedIds.length})
    </Tooltip>
  );

  const renderRejectTooltip = (props) => (
    <Tooltip id="reject-tooltip" {...props}>
      Odrzuć zaznaczone ({selectedIds.length})
    </Tooltip>
  );

  const renderImportTooltip = (props) => (
    <Tooltip id="import-tooltip" {...props}>
      Importuj plik CSV
    </Tooltip>
  );

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderAcceptTooltip}
          >
            <Button className="addresses-button" onClick={onAccept}>
              <img
                src={checkboxIcon}
                alt="Accept Selected"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderRejectTooltip}
          >
            <Button
              className="addresses-button"
              variant="outline-danger"
              onClick={onReject}
            >
              ✕
            </Button>
          </OverlayTrigger>
        </Col>
        {isSuperUser && (
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderImportTooltip}
          >
            <Button
              className="addresses-button"
              variant="outline-success"
              onClick={() => navigate("/data-import/upload")}
            >
              📤
            </Button>
          </OverlayTrigger>
        </Col>
        )}
        <Col xs="auto">
          <Button className="addresses-button" onClick={onSearch}>
            <img
              src={searchIcon}
              alt="Search"
              style={{ width: "75%", height: "75%" }}
            />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default DataImportButtons;
